"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = exports.getInputIndex = exports.isAllowedSymbol = exports.getString = exports.shiftRight = exports.shiftLeft = exports.getInputOrEmpty = exports.formatRegex = exports.Keys = void 0;
var Keys;
(function (Keys) {
    Keys["BACKSPACE"] = "Backspace";
    Keys["ARROW_LEFT"] = "ArrowLeft";
    Keys["ARROW_RIGHT"] = "ArrowRight";
    Keys["DELETE"] = "Delete";
})(Keys = exports.Keys || (exports.Keys = {}));
exports.formatRegex = {
    alpha: /[a-zA-Z]/,
    numeric: /[0-9]/,
    "alpha-numeric": /[a-zA-Z0-9]/,
};
/**
 * Get input by passed index, but if it's null - return empty input object
 * @param inputs - list of inputs
 */
var getInputOrEmpty = function (inputs) { return function (index) { var _a; return (_a = inputs[index]) !== null && _a !== void 0 ? _a : { ref: null, value: "", active: false }; }; };
exports.getInputOrEmpty = getInputOrEmpty;
/**
 * Shift values of inputs to left, from passed index.
 * This is similar to removing element with [Array.splice]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice},
 * but rather than delete element, we just shift values from right to left
 *
 * @example present inputs as string - shiftLeft(["0","1","2","",""], 1) -> ["0", "2", "", "", ""]
 * @param inputs - list of inputs
 * @param from - index of starting shifting
 */
var shiftLeft = function (inputs, from) {
    var _a;
    if (from < 0 || from >= inputs.length)
        return;
    var getInput = exports.getInputOrEmpty(inputs);
    for (var i = from; i < inputs.length; i++) {
        var dest = getInput(i);
        var source = getInput(i + 1);
        if (dest.value === "" && source.value === "")
            break;
        dest.value = (_a = source === null || source === void 0 ? void 0 : source.value) !== null && _a !== void 0 ? _a : "";
    }
};
exports.shiftLeft = shiftLeft;
/**
 * Shift values of inputs to right, from passed index.
 * This is similar to pasting element with [Array.splice]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice},
 * But rather than insert new element after selected index, we just shift them from left to right
 *
 * @example present inputs as string - shiftRight(["0","1","2","",""], 1) -> ["0", "1", "1", "2", ""]
 * @param inputs - list of inputs
 * @param from - shift value of this index to right
 */
var shiftRight = function (inputs, from) {
    if (from < 0 || from >= inputs.length)
        return;
    var getInput = exports.getInputOrEmpty(inputs);
    for (var i = inputs.length - 1; i > from; i--) {
        getInput(i).value = getInput(i - 1).value;
    }
};
exports.shiftRight = shiftRight;
/**
 * Create string from inputs values
 * @param inputs - list of inputs
 */
var getString = function (inputs) { return inputs.reduce(function (value, input) { return value + input.value; }, ""); };
exports.getString = getString;
/**
 * Check is symbol allowed by selected format
 * @param format - format of inputs
 */
var isAllowedSymbol = function (format) { return function (symbol) { return (format === "any"
    || exports.formatRegex[format].test(symbol)); }; };
exports.isAllowedSymbol = isAllowedSymbol;
var getInputIndex = function (elem) { var _a; return parseInt((_a = elem.dataset.index) !== null && _a !== void 0 ? _a : "-1", 10); };
exports.getInputIndex = getInputIndex;
var noop = function () { };
exports.noop = noop;
